import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GENDER_FEATURE_KEY, GenderState, GenderPartialState, genderAdapter } from './gender.reducer';

// Lookup the 'Gender' feature state managed by NgRx
export const getGenderState = createFeatureSelector<GenderPartialState, GenderState>(GENDER_FEATURE_KEY);

const { selectAll, selectEntities } = genderAdapter.getSelectors();

export const getGenderLoaded = createSelector(getGenderState, (state: GenderState) => state.loaded);

export const getGenderError = createSelector(getGenderState, (state: GenderState) => state.error);

export const loadingGender = createSelector(getGenderState, (state: GenderState) => state.loaded);

export const getAllGender = createSelector(getGenderState, (state: GenderState) => selectAll(state));

export const getGenderEntities = createSelector(getGenderState, (state: GenderState) => selectEntities(state));

export const getSelectedId = createSelector(getGenderState, (state: GenderState) => state.selectedGenderId);

export const getSelected = createSelector(
	getGenderEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
